<template>
<div id="create-newsletter">
  <newsletter-form></newsletter-form>
</div>
</template>

<script>
import NewsletterForm from '@/components/NewsletterForm'

import EmailStore from '@/stores/EmailStore'

export default {
  data () {
    return EmailStore.state
  },

  components: {
    'newsletter-form': NewsletterForm
  },

  methods: {
    processErrors (resp) {
      this.$parent.processErrors(resp)
    }
  },

  watch: {
    '$route' (to, from) {
      this.get()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/NewsletterCreate.vue